/**
 * Login page copy, taken verbatim from the legacy Arabic resources.
 *
 * Unlike Install, Locale/Admin/../Login.ar.resx is fully translated, so every
 * string below is the legacy Arabic — nothing is re-worded.
 *
 *   Locale/Login.ar.resx, Locale/Admin/Users.ar.resx, Locale/Admin/General.ar.resx
 *   RawamDemo.sql (Settings -> Default_ArabicApplicationTitle)
 */
export const strings = {
  // Login.ar.resx -> LoginButtonResource1.Text (doubles as the page title)
  title: 'تسجيل الدخول',
  // RawamDemo.sql -> Default_ArabicApplicationTitle
  appTitle: 'روام',

  username: 'اسم المستخدم', // UserNameLabelResource1.Text
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور', // PasswordLabelResource1.Text
  rememberMe: 'تذكرني عند الدخول', // RememberMeCheckBoxResource1.Text
  forgotPassword: 'نسيت كلمة المرور؟', // lblForgotPassword
  userManual: 'دليل المستخدم', // lblUserManual
  newUser: 'لا تمتلك حساب؟ سجل الآن', // lblNewUser
  selectLogin: 'جهة العمل', // LocSelectLogin
  otp: 'كلمة المرور المؤقتة', // txtOTP
  resendOtp: 'إعادة إرسال كلمة المرور', // btnResendOTP
  backToLogin: 'تسجيل الدخول', // LoginButtonResource1.Text, reused as the OTP submit
  sendLoginLink: 'إرسال رابط تسجيل الدخول',

  // Admin/General.ar.resx -> WaitScreenLineA (button progress label)
  submitting: 'فضلا انتظر',
  // Admin/Users.ar.resx -> WaitScreenLineA
  waitScreen: 'فضلا انتظر ...',
  // Admin/Users.ar.resx -> btnClose
  close: 'إغلاق',

  /* The reset-password screen, reached from the emailed link. Wording is the legacy
     resource entries the retired Razor form used. */
  resetPassword: 'ضبط كلمة المرور', // Resources.ar -> lblResetPassword
  newPassword: 'كلمة المرور', // Login.ar.resx -> PasswordLabelResource1.Text
  confirmPassword: 'تأكيد كلمة المرور', // Login.ar.resx -> ConfirmPassword

  localAccount: 'حساب روام المحلي',
  administratorAccess: 'دخول المسؤول',
  administratorAccessHint: 'هذا الدخول مخصص لمسؤولي النظام بالحسابات المحلية فقط.',
  localAccess: 'الدخول بحساب محلي',
  localAccessHint: 'استخدم حسابك المحلي. حساب Microsoft لا يعمل في هذا النموذج.',
  returnToMicrosoft: 'العودة إلى تسجيل الدخول باستخدام Microsoft',
  returnToMagicLink: 'العودة إلى الدخول برابط البريد',
  retryLoginConfig: 'إعادة المحاولة',
  localAccountHint: 'للحسابات المحلية والمسؤولين. لحساب العمل، استخدم زر Microsoft أدناه.',
  signInMicrosoft: 'تسجيل الدخول باستخدام Microsoft',
  or: 'أو',

  messages: {
    invalidLoginLink: 'رابط تسجيل الدخول غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.',
    entraFailed: 'تعذر إكمال تسجيل الدخول عبر Microsoft Entra. حاول مرة أخرى أو تواصل مع مسؤول النظام.',
    // Admin/Users.ar.resx -> RequiredFieldValidator
    required: 'الحقل مطلوب',
    invalidEmail: 'الرجاء إدخال بريد إلكتروني صحيح',
    loginLinkSent: 'تم إرسال رابط تسجيل الدخول إلى بريدك الإلكتروني. يرجى التحقق من صندوق الوارد أو مجلد الرسائل غير المرغوب فيها.',
    passwordMismatch: 'تأكيد كلمة المرور لا يتطابق مع كلمة المرور',
    // Login.ar.resx -> UserNameRequiredMessage
    usernameRequired: 'الرجاء ادخال اسم المستخدم',
    // Login.ar.resx -> ERROR_LOGON_FAILURE_Message
    logonFailure: 'اسم المستخدم أو كلمة المرور خطأ',
    // Login.ar.resx -> ERROR_ACCOUNT_LOCKED_OUT_Message
    lockedOut: 'عذرا حسابك مقفل',
    // Login.ar.resx -> ERROR_ACCOUNT_DISABLED_Message
    disabled: 'لقد تم تعطيل حسابك',
    // Login.ar.resx -> ErrorMessage_1
    checkInput: 'فضلا تأكد من مدخلاتك!',
    // ResetPassword.ar.resx -> ResetLinkSentMessage
    resetLinkSent:
      'لقد أرسلنا إليك بريدا إلكترونيا يحتوي على رابط لإعادة تعيين كلمة المرور الخاصة بك',
    // ResetPassword.ar.resx -> UserNotFoundMessage
    userNotFound: 'المستخدم غير موجود',

    // ---- OTP, from Login.ar.resx ----
    // NewOTPMessage
    newOtp:
      'تم توليد كلمة مرور مؤقتة جديدة و إرسالها إلى البريد الإلكتروني المسجل في النظام، فضلا قم باستخدامها لتحقق من الدخول',
    // ActiveOTPMessage
    activeOtp:
      'كلمة المرور الحالية لم تنتهي صلاحيتها بعد، فضلا قم بإستخدام كلمة المرور التي تم إرسالها من قبل',
    // WrongOtp
    wrongOtp: 'كلمة المرور المؤقتة غير صحيحة، فضلا حاول مرة أخرى',
    // WrongOTPMessage
    otpMismatch: 'كلمة المرور التي تم إدخالها غير مطابقة لكلمة المرور المرسلة، فضلا حاول مرة  أخرى',
    // OTPExpiredMessage
    otpExpired: 'لقد انتهت صلاحية كلمة المرور الحالية، فضلا قم بالنقر على إعادة إرسال كلمة المرور مرة أخرى',

    /* Shown only when the request never reached a handler — the network, or an
       answer that was not JSON. A server that says no says it in its own words
       (W6) and this never replaces that. Resources -> "System Error". */
    systemError: 'حدث خطأ في النظام، فضلا حاول مرة أخرى',
  },

  logoAlt: 'روام',
}
